(() => {
  const initBrandsScrollbar = (root = document) => {
    root.querySelectorAll('.m-brands__slider').forEach((slider) => {
      if (slider.dataset.brandsScrollbarInitialized === 'true') return;

      const section = slider.closest('[data-section-id]') || slider.parentElement;
      const scrollbar = section?.querySelector('.m-brands__scrollbar');
      const track = scrollbar?.querySelector('.m-brands__scrollbar-track');
      const thumb = scrollbar?.querySelector('.m-brands__scrollbar-thumb');

      if (!scrollbar || !track || !thumb) return;

      slider.dataset.brandsScrollbarInitialized = 'true';

      let animationFrame = null;
      let resizeObserver = null;
      let isDragging = false;
      let startX = 0;
      let startScrollLeft = 0;

      const getMeasurements = () => {
        const maxScrollLeft = slider.scrollWidth - slider.clientWidth;
        const trackWidth = track.clientWidth;
        const thumbWidth = maxScrollLeft > 1 ? Math.max((slider.clientWidth / slider.scrollWidth) * trackWidth, 40) : trackWidth;

        return {
          maxScrollLeft,
          trackWidth,
          thumbWidth,
          maxThumbOffset: Math.max(trackWidth - thumbWidth, 0),
        };
      };

      const updateThumb = () => {
        animationFrame = null;

        const { maxScrollLeft, thumbWidth, maxThumbOffset } = getMeasurements();

        if (maxScrollLeft <= 1) {
          scrollbar.classList.add('is-static');
          thumb.style.width = '100%';
          thumb.style.transform = 'translateX(0)';
          return;
        }

        scrollbar.classList.remove('is-static');

        const progress = slider.scrollLeft / maxScrollLeft;
        thumb.style.width = `${thumbWidth}px`;
        thumb.style.transform = `translateX(${maxThumbOffset * progress}px)`;
      };

      const requestUpdate = () => {
        if (animationFrame !== null) return;
        animationFrame = window.requestAnimationFrame(updateThumb);
      };

      const scrollToClientX = (clientX) => {
        const { maxScrollLeft, maxThumbOffset } = getMeasurements();
        if (maxScrollLeft <= 1 || maxThumbOffset <= 0) return;

        const deltaX = clientX - startX;
        slider.scrollLeft = startScrollLeft + deltaX * (maxScrollLeft / maxThumbOffset);
      };

      thumb.addEventListener('pointerdown', (event) => {
        const { maxScrollLeft } = getMeasurements();
        if (maxScrollLeft <= 1) return;

        isDragging = true;
        startX = event.clientX;
        startScrollLeft = slider.scrollLeft;
        scrollbar.classList.add('is-dragging');
        thumb.setPointerCapture(event.pointerId);
        event.preventDefault();
      });

      thumb.addEventListener('pointermove', (event) => {
        if (!isDragging) return;
        scrollToClientX(event.clientX);
      });

      thumb.addEventListener('pointerup', (event) => {
        if (!isDragging) return;
        isDragging = false;
        scrollbar.classList.remove('is-dragging');
        thumb.releasePointerCapture(event.pointerId);
      });

      thumb.addEventListener('pointercancel', () => {
        isDragging = false;
        scrollbar.classList.remove('is-dragging');
      });

      track.addEventListener('pointerdown', (event) => {
        if (event.target === thumb) return;

        const { maxScrollLeft, trackWidth, thumbWidth } = getMeasurements();
        if (maxScrollLeft <= 1) return;

        const trackRect = track.getBoundingClientRect();
        const thumbCenter = thumbWidth / 2;
        const clickPosition = event.clientX - trackRect.left - thumbCenter;
        const progress = clickPosition / Math.max(trackWidth - thumbWidth, 1);

        slider.scrollTo({
          left: Math.max(0, Math.min(maxScrollLeft, progress * maxScrollLeft)),
          behavior: 'smooth',
        });
      });

      slider.addEventListener('scroll', requestUpdate, { passive: true });

      const removeWindowResizeFallback = () => window.removeEventListener('resize', requestUpdate);

      if ('ResizeObserver' in window) {
        resizeObserver = new ResizeObserver(requestUpdate);
        resizeObserver.observe(slider);
        resizeObserver.observe(track);
      } else {
        window.addEventListener('resize', requestUpdate);
      }

      slider.brandsScrollbarCleanup = () => {
        if (animationFrame !== null) {
          window.cancelAnimationFrame(animationFrame);
        }

        resizeObserver?.disconnect();
        removeWindowResizeFallback();
        delete slider.brandsScrollbarCleanup;
      };

      requestUpdate();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initBrandsScrollbar());
  } else {
    initBrandsScrollbar();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initBrandsScrollbar(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('.m-brands__slider').forEach((slider) => {
      slider.brandsScrollbarCleanup?.();
    });
  });
})();
